<template>
  <div>
    <div class="container-fluid mt--7">
      <div class="card shadow mb-3">
        <div class="row">
          <div class="col-md-4 mt-4">
            <div class="form-group">
              <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                  <li class="breadcrumb-item">
                    <a href="/inicio">Início</a>
                  </li>
                  <li class="breadcrumb-item">
                    <a style="color: grey; hover: none"> Colunistas </a>
                  </li>
                </ol>
                <h3 style="color: #000; margin-left: 15px">Colunistas</h3>
              </nav>
            </div>
          </div>
          <div class="col-md-3 offset-5 div_btn_usuario mt-6">
            <div class="form-group">
              <router-link to="/cadastrar-colunista">
                <button
                  style="margin-right: 10px"
                  type="button"
                  class="btn_add"
                >
                  Cadastrar Colunista
                </button>
              </router-link>
            </div>
          </div>
        </div>
      </div>

      <div class="card shadow div_tabela">
        <div class="row justify-content-center">
          <div class="col-11">
            <div class="table-responsive">
              <table
                class="table tablesorter table align-items-center text-center table-flush"
              >
                <thead class="thead-light" style="border: solid 5px white">
                  <th>Código</th>
                  <th>Nome</th>
                  <th>Status</th>
                  <th>Ação</th>
                </thead>

                <tbody class="list">
                  <corpo-tabela-colunista
                    v-for="colunista in state.colunistas"
                    :key="colunista.id"
                    :colunista="colunista"
                    @deletarColunista="deletarColunista"
                  />
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  <script>
import { onMounted, reactive } from "vue";
import CorpoTabelaColunista from "../../components/CorpoTabelaColunista";
import services from "../../services";
import { useStorage } from "vue3-storage";

export default {
  components: {
    CorpoTabelaColunista,
  },
  setup() {
    const storage = useStorage();
    var token = storage.getStorageSync("token");
    const state = reactive({
      colunistas: [],
    });
    onMounted(() => {
      fetchColunista();
    });
    async function fetchColunista() {
      try {
        const { data } = await services.colunista.getAll({ token });
        state.colunistas = data;
      } catch (error) {
        console.log(error);
      }
    }
    async function deletarColunista(id) {
      if (
        confirm(
          "Ao deletar colunista a coluna que o mesmo estiver vinculada será apagada! Deseja deletar colunista?"
        )
      ) {
        try {
          state.isLoading = true;
          const { data } = await services.colunista.delete({
            id: id,
            token,
          });
          console.log(data.status);
          if (data.status != 200) {
            alert("Erro ao deletar colunista.");
          } else {
            fetchColunista();
          }
        } catch (error) {
          console.log(error);
        }
      }
    }
    return {
      state,
      deletarColunista,
    };
  },
};
</script>

<style scoped>
table {
  color: black;
}

.div_tabela {
  height: auto;
}
.div_btn_usuario {
  text-align: right;
}
.breadcrumb {
  background: #fff;
  margin-bottom: 0;
}
a {
  color: #000;
  font-family: "PoppinsMedium";
  transition: 0.2s;
}
a:hover {
  color: #93c01f;
}
</style>